module.exports = __webpack_public_path__ + "static/media/bg-tools.608b6d94.svg";